const onResponse = (res) => {
    return res.ok ? res.json() : Promise.reject(res)
}

class Api {
    constructor()
    {
        this._url = "/api/";
    }


    async getData(method, data) {
        const responce = await fetch(`${this._url}/getData.php`,{
            method: "post",   
            headers: {"Content-Type": "application/json"},         
            body: JSON.stringify({"method": method, "data": data}),
        });
        const result = await onResponse(responce);
        return result;
    }



    
}

export default Api;